export default __webpack_public_path__ + "static/media/OGJ-Type-Design-Sequel-Sans-Book-Head.5e188ad0.woff";